import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { DataService } from 'src/app/data.service';
import { environment } from 'src/environments/environment';
import { sajatNezetFelretesz } from 'src/app/jogkor-nezet-tarolo';

/**
 *  BELÉPÉS MÁS NEVÉBEN – admin nézetváltás teszteléshez.
 *
 *  Mire való: egy gombnyomással átváltani egy másik felhasználó NÉZETÉRE, hogy
 *  látszódjon, mit lát az illető – milyen menüi vannak, mely képernyők nyílnak meg.
 *  A „nálam működik, nála nem" típusú bejelentést enélkül csak találgatva lehet
 *  reprodukálni.
 *
 *  Amit NEM tud, és amit nem szabad félreérteni: a kiszolgáló felé továbbra is a SAJÁT
 *  tokened megy, tehát a háttérben a te jogosultságaid érvényesek. Ez azt mutatja meg,
 *  MIT LÁT a felhasználó – nem azt bizonyítja, hogy amit nem lát, azt el sem érné.
 *
 *  Minden nézetváltás naplózódik (ki, kinek a nevében, mikortól meddig): idegen adatba
 *  belenézni akkor is beavatkozás, ha csak nézés.
 */
@Component({
  selector: 'app-admin-impersonalas',
  templateUrl: './impersonalas.component.html',
  styleUrls: ['./impersonalas.component.scss'],
})
export class AdminImpersonalasComponent implements OnInit {

  intezmeny = '';
  jogosult = false;
  sajat = '';
  /*  Az elutasítás OKA. Enélkül a képernyő mindhárom, gyökeresen különböző esetre
   *  ugyanazt írta ki („nincs jogosultságod"), és a leggyakoribb ok - hogy a kérés
   *  kiléte veszett el útközben - így megkülönböztethetetlen volt a valódi
   *  jogosultsághiánytól. */
  ok = '';
  /*  Ha a kilét azért hiányzik, mert a token nem jutott el vagy nem volt érvényes,
   *  a kiszolgáló megmondja, melyik ellenőrzésen bukott el. Négy teendő, négy üzenet. */
  tokenOk = '';
  tokenReszlet = '';
  /*  A KIBOCSÁTÓ-ELTÉRÉS a leggyakoribb néma hiba: az alkalmazás az egyik azonosítási
   *  kiszolgálótól kapja a tokent, a háttér viszont egy másikat vár. Ilyenkor MINDEN
   *  token elbukik, a rendszer mégis működni látszik – csak épp senkit nem ismer fel.
   *  A két címet ezért összevetjük, és ha eltér, kimondjuk. */
  sajatKibocsato = '';
  vartKibocsato = '';
  get kibocsatoElter(): boolean {
    return !!this.sajatKibocsato && !!this.vartKibocsato
      && this.sajatKibocsato.replace(/\/+$/, '') !== this.vartKibocsato.replace(/\/+$/, '');
  }
  jogkorok: string[] = [];
  hibaSzoveg = '';
  /*  A LISTA HIBÁJA NEM JOGOSULTSÁGI HIBA.
   *
   *  Ha a jogosultság-ellenőrzés már rendben lefutott, egy elhasalt lista- vagy
   *  napló-lekérés nem jelenti azt, hogy nincs jogod – korábban mégis azt írta ki
   *  a képernyő, és a valódi ok (egy kiszolgáló-oldali hiba) elveszett benne.
   */
  listaHiba = '';
  toltodik = true;
  fut = false;

  felhasznalok: any[] = [];
  naplo: any[] = [];

  kereses = '';
  tipusSzuro = 'mind';
  /*  Gondviselő és tanuló CSAK az iskolában (SULINFORM) van. A többi modulban a
   *  felhasználó munkatárs vagy ügyfél – a kiszolgáló is csak őket adja (`mode`). */
  mode = 'SULINFORM';
  get sulinform(): boolean { return this.mode === 'SULINFORM'; }
  private readonly iskolaiTipusok = [
    { id: 'mind', nev: 'Mind' },
    { id: 'dolgozo', nev: 'Dolgozó' },
    { id: 'gondviselo', nev: 'Gondviselő' },
    { id: 'tanulo', nev: 'Tanuló' },
  ];
  private readonly modulTipusok = [
    { id: 'mind', nev: 'Mind' },
    { id: 'munkatars', nev: 'Munkatárs' },
    { id: 'ugyfel', nev: 'Ügyfél' },
  ];
  get tipusok() { return this.sulinform ? this.iskolaiTipusok : this.modulTipusok; }

  readonly tipusNevek: any = { dolgozo: 'dolgozó', gondviselo: 'gondviselő', tanulo: 'tanuló', munkatars: 'munkatárs', ugyfel: 'ügyfél' };

  /** A sor típusa a szűrőhöz és a címkéhez: az iskolán kívül munkatárs / ügyfél. */
  tipusa(f: any): string { return this.sulinform ? f.tipus : (f.fajta || 'munkatars'); }

  constructor(private http: HttpClient, private data: DataService) {}

  async ngOnInit() {
    const sajatIntezmeny = await this.data.getFromStorage('sajatIntezmeny');
    this.intezmeny = sajatIntezmeny?.intezmenyId || '';
    this.mode = String((await this.data.getFromStorage('currentMode')) || 'SULINFORM');
    await this.betolt();
  }

  private get ut() { return encodeURI(this.intezmeny); }

  async betolt() {
    this.toltodik = true;
    try {
      const allapot: any = await firstValueFrom(
        this.http.get(`/api/impersonalas/allapot/${this.ut}`));
      this.jogosult = !!allapot?.jogosult;
      this.sajat = allapot?.sajat || '';
      this.ok = allapot?.ok || '';
      this.tokenOk = allapot?.token_ok || '';
      this.tokenReszlet = allapot?.token_reszlet || '';
      this.jogkorok = allapot?.jogkorok || [];
      this.listaHiba = '';
      if (!this.jogosult) { await this.kibocsatoEllenoriz(); return; }

      /*  A lista és a napló KÜLÖN hibázhat, és az nem érinti a jogosultságot.
       *  Ezért itt saját kezelés van: a képernyő nyitva marad, csak azt mondjuk meg,
       *  hogy a lista nem töltődött be – nem azt, hogy nincs jogod.
       */
      try {
        const [lista, naplo]: any = await Promise.all([
          firstValueFrom(this.http.get(`/api/impersonalas/felhasznalok/${this.ut}?mode=${encodeURIComponent(this.mode)}`)),
          firstValueFrom(this.http.get(`/api/impersonalas/naplo/${this.ut}`)),
        ]);
        this.felhasznalok = Array.isArray(lista) ? lista : [];
        this.naplo = Array.isArray(naplo) ? naplo : [];
      } catch (e: any) {
        this.felhasznalok = [];
        this.naplo = [];
        this.listaHiba = e?.error?.error || e?.message || 'ismeretlen hiba';
      }
    } catch (e: any) {
      this.jogosult = false;
      this.ok = 'lekerdezes-hiba';
      this.hibaSzoveg = e?.error?.error || e?.message || '';
    } finally {
      this.toltodik = false;
    }
  }

  /*  A háttér által VÁRT kibocsátó lekérése, és összevetés a sajátunkkal.
   *  Nem titok: a kibocsátó címe minden tokenben benne van.
   */
  private async kibocsatoEllenoriz() {
    this.sajatKibocsato = `${environment.keycloak}/realms/master`;
    try {
      const v: any = await firstValueFrom(this.http.get('/api/version'));
      this.vartKibocsato = v?.auth?.kibocsato || '';
    } catch (e) { this.vartKibocsato = ''; }
  }

  /** Emberi magyarázat az elutasításra – ok szerint, nem egy szöveg mindenre. */
  get okMagyarazat(): string {
    switch (this.ok) {
      case 'nincs-azonositott-felhasznalo':
        switch (this.tokenOk) {
          case 'nincs-token':
            return 'A kérés belépési token NÉLKÜL érkezett a kiszolgálóra. Ez nem jogosultsági '
              + 'kérdés. Lépj ki és be újra; ha így is ezt látod, a böngésző vagy a peremhálózat '
              + 'nem küldi tovább az Authorization fejlécet.';
          case 'lejart-token':
            return 'A belépési munkameneted lejárt. Lépj ki és be újra.';
          case 'rossz-kibocsato':
            return 'A belépési token MÁS azonosítási kiszolgálótól származik, mint amit ez a '
              + 'telepítés elfogad. Ez beállítási eltérés a kiszolgálón (kibocsátó cím), nem '
              + 'a te fiókoddal van baj.';
          case 'nem-ehhez-az-alkalmazashoz':
            return 'A belépési token nem ehhez az alkalmazáshoz szól (kliens-azonosító eltérés). '
              + 'Ez a kiszolgáló beállítása, nem a te fiókod.';
          case 'kulcs-nem-elerheto':
            return 'A kiszolgáló nem éri el a belépési rendszer ellenőrző kulcsait, ezért egyetlen '
              + 'tokent sem tud érvényesíteni. Ez kiszolgáló-oldali hiba (hálózat vagy cím), '
              + 'nem a te fiókod.';
          case 'ervenytelen-token':
            return 'A belépési token ellenőrzése nem sikerült. Lépj ki és be újra; ha így is ezt '
              + 'látod, a kiszolgáló és a belépési rendszer beállítása tér el.';
          default:
            return 'A kérés úgy érkezett a kiszolgálóra, hogy nem lehetett megállapítani, ki küldte. '
              + 'Ez nem jogosultsági kérdés: a belépési token vagy nem ment el a kéréssel, vagy '
              + 'lejárt. Lépj ki és be újra.';
        }
      case 'nincs-feladatellatas':
        return `A(z) ${this.intezmeny} intézményben nincs feladatellátásod, ezért itt nem `
          + 'válthatsz nézetet. Másik intézmény adminisztrátoraként sem – a jogosultság '
          + 'intézményhez kötött.';
      case 'nincs-admin-jogkor':
        return 'Van feladatellátásod ebben az intézményben, de nem adminisztrátori jogkörrel'
          + (this.jogkorok?.length ? ` (jelenlegi jogköreid: ${this.jogkorok.join(', ')})` : '')
          + '. A nézetváltáshoz „admin" vagy „rendszergazda" jogkör kell.';
      case 'lekerdezes-hiba':
        return 'A jogosultság ellenőrzése nem sikerült' + (this.hibaSzoveg ? `: ${this.hibaSzoveg}` : '.');
      default:
        return 'Ehhez a funkcióhoz intézményi adminisztrátori jogosultság kell.';
    }
  }

  /** Névsorban, keresővel és típus szerint szűrve. */
  get szurtLista(): any[] {
    const keres = this.kereses.trim().toLowerCase();
    return (this.felhasznalok || [])
      .filter((f) => this.tipusSzuro === 'mind' || this.tipusa(f) === this.tipusSzuro)
      .filter((f) => !keres
        || String(f.nev || '').toLowerCase().includes(keres)
        || String(f.azonosito || '').toLowerCase().includes(keres))
      .sort((a, b) => String(a.nev || '').localeCompare(String(b.nev || ''), 'hu'))
      .slice(0, 300);
  }

  /**
   *  Nézetváltás indítása.
   *
   *  A sorrend fontos: előbb a kiszolgáló naplózza a menetet (ha az nem sikerül, nem
   *  váltunk), aztán ÜRÍTJÜK a tárolót – különben a saját menü, jogkör és törzsadat
   *  bent maradna, és keveredne a célfelhasználóéval –, és csak utána tesszük le a
   *  jelölőt, ami a takarítást túléli.
   */
  async belep(f: any) {
    if (!confirm(`Átváltasz ${f.nev || f.azonosito} nézetére.\n\n`
      + 'A saját fiókodba a felül megjelenő sávról tudsz visszatérni.\n'
      + 'A nézetváltás naplózódik.')) return;
    this.fut = true;
    try {
      const r: any = await firstValueFrom(this.http.post('/api/impersonalas/kezd', {
        intezmeny: this.intezmeny, cel: f.azonosito, tipus: f.tipus, cel_nev: f.nev, mode: this.mode,
      }));
      await this.data.clearStorage();
      /*  A SAJÁT JOGKÖR-NÉZET FÉLRETÉVE. Eddig ott maradt: a menü a tanuló nevében is
       *  az admin nézet-jogkörével töltött, a választó az admin jogköreit kínálta. A
       *  nézet a jelölőbe kerül, és a visszatéréskor (AppComponent.impersonalasVege)
       *  visszaáll. A kiszolgálón a menete nyitva marad – az az admin kilétéhez kötött,
       *  a cél nevében amúgy sem hat (jogkor-nezet.js › keroKulcsok). */
      const sajatJogkorNezet = sajatNezetFelretesz();
      localStorage.setItem('cronom_impersonalas', JSON.stringify({
        menet: r?.menet, cel: f.azonosito, tipus: f.tipus, cel_nev: f.nev,
        admin: r?.admin || this.sajat, intezmeny: this.intezmeny,
        sajat_jogkor_nezet: sajatJogkorNezet,
      }));
      window.location.href = '/';
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A nézetváltás nem indult el.', 'error');
      this.fut = false;
    }
  }
}
